import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class ModalTrigger implements Plugin {
  constructor(private readonly element: HTMLElement) {}

  init(): void {
    this.element.addEventListener("click", (e) => {
      e.preventDefault();
      const targetModalId = this.element.dataset.modal;
      if (targetModalId) {
        const modalElement = document.getElementById(targetModalId);

        if (modalElement) {
          modalElement.dispatchEvent(new CustomEvent("modal:open"));
        } else {
          console.warn(
            `ModalTrigger: Modal com ID "${targetModalId}" não encontrado.`,
          );
        }
      }
    });
  }
}

PluginRegistry.register("modal-trigger", ModalTrigger);
